import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DrawerModule } from 'primeng/drawer';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';

export interface PontoCritico {
  id: number;
  ordem: number;
  idPontoCritico: number;
  designacao: string;
  checado: boolean;
  dataChecagem: string;
}

export interface RondaDetail {
  id: number;
  idEscala: number;
  idPosto: number;
  nomePosto: string;
  idEfetivo: number;
  nomeEfetivo: string;
  nomeTurno: string;
  dataInicio: string;
  dataFim: string | null;
  observacao: string | null;
  concluida: boolean;
  totalPontos: number;
  totalPontosChecados: number;
  pontosCriticos: PontoCritico[];
  efetivosIds: number[];
}

@Component({
  selector: 'app-detalhe-ronda',
  standalone: true,
  imports: [
    CommonModule,
    DrawerModule,
    TagModule,
    ButtonModule,
    DatePipe
  ],
  templateUrl: './detalhe-ronda.component.html',
  styleUrls: ['./detalhe-ronda.component.scss']
})
export class DetalheRondaComponent {
  @Input() visible: boolean = false;
  @Input() ronda: RondaDetail | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onHide(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  trackByPontoId(index: number, ponto: PontoCritico): number {
    return ponto.id;
  }
}